@if (showColorOptions) {
<div class="agile-color-options-container">
  <p-select
    #boardStyleSelect
    [options]="colorOptions"
    [(ngModel)]="selectedDisplay"
    name="boardStyle"
    optionLabel="label"
    optionValue="value"
    (onChange)="onSelectionChange($event)"
    (onPanelHide)="onPanelHide()"
    placeholder="Board Style"
    [showClear]="false"
    [autoDisplayFocus]="false"
    appendTo="body"
    class="board-style-dropdown">
    <ng-template let-option pTemplate="item">
      <div class="board-style-option" (click)="handleOptionClick($event, option.value.key)">
        <p-checkbox [ngModel]="option.value.checked" binary="true"> </p-checkbox>
        <span class="option-label">{{ option.value.label }}</span>
      </div>
    </ng-template>
  </p-select>
</div>
}
